export const TrailerDirection = {
  ALL: 'None',
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound',
};

export type TrailerDirection = (typeof TrailerDirection)[keyof typeof TrailerDirection];
